import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { regionName } from "@/hooks/useAgentServerRegions";

// Shown under a region picker whose saved region has no live server.
// `consequence` says what breaks, for example "V2 calls for this assistant will fail".
export function NoLiveServerNotice({
  region,
  consequence,
}: {
  region: string;
  consequence: string;
}) {
  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription>
        No agent server is running in {regionName(region)} right now. {consequence}{" "}
        until one is back.
      </AlertDescription>
    </Alert>
  );
}

export function RegionsLoadFailedNote() {
  return (
    <p className="text-sm text-muted-foreground">
      Could not load regions. The saved value is shown; try reopening this section.
    </p>
  );
}
